import type { StarlinkDocument } from 'core/domains';
import { PlainObject } from 'core/utilities';

type Document = {
  component: string;
  layout: PlainObject;
  options: PlainObject;
  config: PlainObject;
};

export const starlinkResponsePresenter = ({ data: { components, items } }: StarlinkDocument) => {
  const hasUnvalidComponents = !components || components.length === 0;
  const hasUnvalidItems = !items || items.length === 0 || !items[0].data;

  if (hasUnvalidComponents && hasUnvalidItems) {
    return {
      components: [],
    };
  }
  const data = components as unknown as Document[];

  const response =
    data?.map((component) => {
      return {
        ...component,
        config: {
          ...component.options,
          featureToggle: true,
        },
        component: component.component?.toLocaleLowerCase() || '',
      };
    }) ||
    items[0].data ||
    [];

  return {
    components: response,
  };
};
